<template>
  <div>
    <AppLayout title="Fornecedores">
      <template #actions>
        <button type="button" @click="show_newSupplier()" class="btn btn-primary">Novo Fornecedor</button>
      </template>

      <div class="table-card">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>Nome</th>
              <th>Telefone</th>
              <th>Email</th>
              <th>Cidade</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="fornecedor in lista_fornecedores">
              <td><button type="button" class="btn btn-info btn-sm"><i class="bi bi-box-seam-fill"></i></button></td>
              <td>{{ fornecedor.name }}</td>
              <td>{{ fornecedor.phone ?? '' }}</td>
              <td>{{ fornecedor.email ?? '' }}</td>
              <td>{{ (fornecedor.city ?? ' ') + ' - ' + (fornecedor.state ?? ' ') }}</td>
              <td style="width:50px"><button @click="show_editSupplier(fornecedor)" type="button" class="btn btn-primary btn-sm"><i class="bi bi-pencil-square"></i></button></td>
              <td style="width:50px"><button @click="show_deletSupplier(fornecedor)" :disabled="autorizated_delet == 0" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </AppLayout>

    <!-- Modal Fornecedor -->
    <div class="modal fade" id="modal_fornecedor" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div v-if="edit" >
              <h5 class="modal-title">Editar Produto</h5>
            </div>
            <div v-else >
              <h5  class="modal-title">Novo Produto</h5>
            </div>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-produto">
              <div class="mb-3">
                <label for="inp_name" class="form-label">Nome:</label>
                <input v-model="fornecedor.name" type="text" class="form-control" name="inp_name" id="inp_name">
              </div>
              <div class="row">
                <div class="mb-3 col">
                  <label for="inp_phone" class="form-label">Telefone:</label>
                  <input v-model="fornecedor.phone" type="phone" class="form-control" name="inp_phone" id="inp_phone">
                </div>
                <div class="mb-3 col">
                  <label for="inp_email" class="form-label">Email:</label>
                  <input v-model="fornecedor.email" type="email" class="form-control" name="inp_email" id="inp_email">
                </div>
              </div>
              <div class="mb-3">
                  <label for="inp_andress" class="form-label">Endereço:</label>
                  <input v-model="fornecedor.andress" type="text" class="form-control" name="inp_andress" id="inp_andress">
              </div>
              <div class="row">
                <div class="mb-3 col">
                  <label for="inp_city" class="form-label">Cidade:</label>
                  <input v-model="fornecedor.city" type="text" class="form-control" name="inp_city" id="inp_city">
                </div>
                <div class="mb-3 col">
                  <label for="inp_state" class="form-label">Estado:</label>
                  <input v-model="fornecedor.state" type="text" class="form-control" name="inp_state" id="inp_state">
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button type="submit" @click="actionProduct()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Deletar Fornecedor?</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ fornecedor.name }}</p>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button @click="deleteSupplier()" class="btn btn-danger">Deletar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Sucesso</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ msn_feedback }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
    import http from "@/services/http.js";
    import {useAuth} from "@/services/auth.js";
    import {  onMounted, reactive, ref } from 'vue';
    import { Modal } from "bootstrap";
    import AppLayout from "@/components/AppLayout.vue";
    import { fornecedores } from "@/models/fornecedores";
    import { produtos } from "@/models/produtos";

    export default {
      name: 'SupplierView',
      components: {
        AppLayout
      },
      setup(props) {
      const lista_fornecedores = ref([]);
      const Forncedores = fornecedores();

      var edit = ref(false);
      var msn_feedback = ref('');
      var autorizated_delet = ref(true);

      let modal = '';

      var fornecedor = reactive({
        'id':'',
        'name':'',
        'phone':'',
        'email':'',
        'city':'',
        'state':'',
        'andress':'',
      })

      function openModal(elemento) {
        const modalNovoProduto = document.getElementById(elemento);
        modal = new Modal(modalNovoProduto);
        modal.show();
      };

      function closeModal() {
        modal.hide();
      };

      function limparDados() {
        fornecedor.id = '';
        fornecedor.name = '';
        fornecedor.phone = '';
        fornecedor.email = '';
        fornecedor.city = '';
        fornecedor.state = '';
        fornecedor.andress = '';
      };

      const show_editSupplier = (item) => {
        edit.value = true;
        fornecedor.id = item.id;
        fornecedor.name = item.name;
        fornecedor.phone = item.phone;
        fornecedor.email = item.email;
        fornecedor.city = item.city;
        fornecedor.state = item.state;
        fornecedor.andress = item.andress;
        openModal('modal_fornecedor');
      }

      const show_newSupplier = (item) => {
        limparDados();
        edit.value = false;
        openModal('modal_fornecedor');
      }

      const show_deletSupplier = (item) => {
        limparDados();
        edit.value = true;
        fornecedor.id = item.id;
        fornecedor.name = item.name;
        fornecedor.phone = item.phone;
        fornecedor.email = item.email;
        fornecedor.city = item.city;
        fornecedor.state = item.state;
        fornecedor.andress = item.andress;
        openModal('modal_deletar');
      }

      const saveSupplier = async () => {
        if (await Forncedores.createItem(fornecedor)) {
          closeModal();
          msn_feedback.value = 'Fornecedor cadastrado com sucesso!';
          openModal('modal_feedback');
          limparDados();
          listSuppliers();
        } else {
          console.log('Erro ao cadastrar novo fornecedor');
        }
      }

      const listSuppliers = async () => {
        lista_fornecedores.value = await Forncedores.list()
      }

      onMounted(function () {
        listSuppliers();
      });

      const deleteSupplier = async () => {
        if (await Forncedores.deleteItem(fornecedor.id)) {
          closeModal();
          msn_feedback.value = 'Fornecedor deletado com sucesso!';
          openModal('modal_feedback');
          listSuppliers();
        } else {
          console.log('Erro ao deletar fornecedor');
        }
      }

      const updateSupplier = async () => {
        if (await Forncedores.updateItem(fornecedor)) {
          msn_feedback.value = "Fornecedor atualizado com sucesso!"
          closeModal();
          openModal('modal_feedback');
          listSuppliers();
        } else {
          console.log('Erro ao atualizar fornecedor');
        }
      }

      const actionProduct = () => {
        if (edit.value) {
          updateSupplier();
        } else {
          saveSupplier();
        }
      }

      return {
        fornecedor,
        msn_feedback,
        autorizated_delet,
        edit,
        lista_fornecedores,
        openModal,
        show_editSupplier,
        show_newSupplier,
        show_deletSupplier,
        deleteSupplier,
        actionProduct
      }
      },
    }
</script>
